"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZuoraCreateBusinessSubscriptionPayloadSchema = void 0;
exports.ZuoraCreateBusinessSubscriptionPayloadSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        messageId: {
            type: 'string',
        },
        eventDate: {
            type: 'string',
            minLength: 1,
        },
        eventType: {
            type: 'string',
        },
        serviceContractId: {
            type: 'string',
            minLength: 1,
        },
        currencyIsoCode: {
            type: 'string',
            minLength: 1,
        },
        subscriptionTerm: {
            type: 'string',
            minLength: 1,
        },
        source: {
            type: 'string',
        },
        isTrial: {
            type: 'boolean'
        },
        contact: {
            type: 'object',
            properties: {
                firstName: {
                    type: 'string',
                },
                lastName: {
                    type: 'string',
                    minLength: 1,
                },
                email: {
                    type: 'string',
                },
                sonosId: {
                    type: 'string',
                    minLength: 1,
                },
                billingCountry: {
                    type: 'string',
                    minLength: 1,
                },
                billingCity: {
                    type: 'string',
                    minLength: 1,
                },
                billingPostalCode: {
                    type: 'string',
                    minLength: 1,
                },
                billingStateCode: {
                    type: 'string',
                },
                billingStreetLine1: {
                    type: 'string',
                },
                billingStreetLine2: {
                    type: 'string',
                },
            },
            required: [
                'firstName',
                'lastName',
                'sonosId',
                'billingCountry',
                'billingCity',
                'billingPostalCode',
            ],
        },
        salesAccount: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    minLength: 1,
                },
                accountId: {
                    type: 'string',
                },
                defaultPaymentMethod: {
                    type: 'object',
                    properties: {
                        paymentGateway: {
                            type: 'string',
                        },
                        externalId: {
                            type: 'string',
                        },
                    },
                },
                externalId: {
                    type: 'string',
                },
            },
            required: [
                'id',
                'accountId',
            ],
        },
        contractRatePlans: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    externalId: {
                        type: 'string',
                    },
                    sequenceSetId: {
                        type: 'string',
                        minLength: 1,
                    },
                    communicationProfileId: {
                        type: 'string',
                        minLength: 1,
                    },
                    invoiceTemplateId: {
                        type: 'string',
                    },
                    legalEntity: {
                        type: 'string',
                        minLength: 1,
                    },
                    chargeableUnits: {
                        type: 'number',
                    },
                    collectPaymentOnActivate: {
                        type: 'boolean',
                    },
                },
                required: [
                    'externalId',
                    'sequenceSetId',
                    'communicationProfileId',
                    'legalEntity',
                    'chargeableUnits',
                    'collectPaymentOnActivate',
                ],
            },
        },
    },
    required: [
        'eventDate',
        'currencyIsoCode',
        'subscriptionTerm',
        'serviceContractId',
        'eventType',
        'source',
        'contact',
        'salesAccount',
        'contractRatePlans'
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,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